<template>
  <CardFlat :title="heading">
    <template #title>{{ heading }} </template>
    <img
      loading="lazy"
      :src="valuationFunnelImage"
      :alt="t('valuationFunnelTile.headerImageAltText')"
    />
    <HgButton
      tag="a"
      :class="$style.ctaButton"
      :href="valuationFunnelUrl"
      @click="trackValuationBoxCta"
      >{{ t('valuationFunnelTile.buttonText') }}</HgButton
    >
    <div :class="$style.horizontal" />
    <div class="row">
      <div
        v-for="feature in featureList"
        :key="feature"
        :class="['col', $style.featureTextWrapper]"
      >
        <HgIcon icon="Check" size="small" /><label :class="$style.featureText">{{ feature }}</label>
      </div>
    </div>
  </CardFlat>
</template>
<script setup lang="ts">
import { HgButton, HgIcon } from '@smg-real-estate/domus';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import valuationFunnelImage from '@/assets/valuation-funnel-hero-image.webp';
import { CardFlat } from '@/components/common';
import { PropertyType } from '@/models/iazi/common/enums';
import useMapStore from '@/stores/useMapStore';
import { trackValuationBoxCta } from '@/tracking';
import { getValuationFunnelUrl } from '@/utils/functions';

const { t } = useI18n();
const { propertyType: propType } = storeToRefs(useMapStore());

const heading = computed<string>((): string =>
  propType.value === PropertyType.Apartment
    ? t('valuationFunnelTile.header.apartment')
    : t('valuationFunnelTile.header.house'),
);
const featureList = computed<Array<string>>(() => [
  t('valuationFunnelTile.freeLabel'),
  t('valuationFunnelTile.onlineLabel'),
  t('valuationFunnelTile.timeLabel'),
]);

const valuationFunnelUrl = computed<string>((): string => getValuationFunnelUrl(t));
</script>

<style lang="scss" module>
@use '@/styles/variables' as *;

img {
  width: 100%;
  height: auto;
}

.ctaButton {
  width: 100%;
  margin: $space-100 0;
}

.featureTextWrapper {
  display: flex;
  gap: $space-50;
  align-items: center;
  justify-content: center;

  &:first-child {
    justify-content: left;
  }

  &:last-child {
    justify-content: right;
  }
}

.featureText {
  margin-left: $space-25;

  @include body-2;
}

.horizontal {
  width: 100%;
  height: 1px;
  margin: $space-50 0 $space-100;
  background-color: $color-grey-60;
}
</style>
